module.exports = __webpack_public_path__ + "static/media/gmail.38b051bc.svg";